<template>
  <div class="container do-receipt">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'todoReceiptList',
          title: '待收货'
        },
        {
          name: 'doReceipt',
          title: '生成收货单'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>采购订单号：{{purchaseOrder.code}}</h4>
            <div>创建时间：{{purchaseOrder.createTime}}</div>
            <div>供应商：{{purchaseOrder.supplierName}}</div>
            <div>成本类型：{{purchaseOrder.paymentName}}</div>
          </div>
          <div class="info-item">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>

      <div slot="content">
        <lk-card title="商品详情">
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{goodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{purchaseAmount}}</div>
          </div>
          <DtpTable border :columns="columns" :data="tableData" class="plan-table"/>
        </lk-card>
        <lk-card title="补充信息" class="other-card">
          <lk-form
            :label-width='134'
            label-position="right"
            ref="purchaseReceiptForm"
            :model="purchaseReceipt"
            :rules="purchaseReceiptRule">
            <lk-row
              :gutter='16'
              v-for="(item, index) in purchaseReceipt.purchaseReceiptImgInfoList"
              :key="index"
              >
              <lk-col span="7">
                <lk-form-item
                  label="温度附件图:"
                >
                  <Uploader :able="true" v-model="item.temperatureImg"></Uploader>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="温度图备注:">
                  <lk-input :maxlength='100' v-model="item.imgComment" placeholder="请输入"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="purchaseReceipt.purchaseReceiptImgInfoList.length < 5">
              <lk-col span="7">
                <lk-form-item
                  label="温度附件图:"
                  prop="purchaseReceiptImgInfoList"
                  :class="{'ivu-form-item-required': purchaseReceiptRule.purchaseReceiptImgInfoList[0].required}">
                  <Uploader :able="true" @handle="imgHandle"></Uploader>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="温度图备注:">
                  <lk-input v-model="tempInput" :maxlength='100' placeholder="请输入"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="拒收商品:">
                  <lk-button type="primary" @click="showAddRejectGoods">添加</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="23">
                <lk-form-item>
                  <lk-table :data="rejectData" :columns="rejectColumn" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="供应商仓库名:">
                  <lk-input v-model="purchaseReceipt.supplierInventory" :maxlength='30' placeholder="请输入"/>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item
                  label="运输方式:"
                  :class="{'ivu-form-item-required':purchaseReceiptRule.transportModeId[0].required }"
                  prop="transportModeId" >
                  <lk-select v-model="purchaseReceipt.transportModeId" placeholder="请选择">
                    <lk-option
                      v-for="item in transportModeList"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label">
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>

              <lk-col span="7" offset="1" v-if="purchaseReceipt.transportModeId === 4">
                <lk-form-item label="承运方式:" prop="carryMode">
                  <lk-select v-model="purchaseReceipt.carryMode" placeholder="请选择">
                    <lk-option
                      v-for="item in carryModeList"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label">
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" v-if="purchaseReceipt.transportModeId === 4">
                <lk-form-item label="承运单位:" prop="carrier">
                  <lk-input v-model="purchaseReceipt.carrier" :maxlength="20" placeholder="请输入"/>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="车牌号:">
                  <lk-input v-model="purchaseReceipt.licensePlate" :maxlength='20' placeholder="请输入"/>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" :offset="purchaseReceipt.transportModeId === 4 ? 1 : 0">
                <lk-form-item
                  label="起运时间:"
                  prop="transTimeStart"
                  :class="{'ivu-form-item-required':purchaseReceiptRule.transTimeStart[0].required }">
                  <timeStampDatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="purchaseReceipt.transTimeStart" style="width: 100%" placeholder="请输入"/>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" :offset="purchaseReceipt.transportModeId === 4 ? 0 : 1">
                <lk-form-item
                label="到货时间:"
                prop="transTimeEnd"
                :class="{'ivu-form-item-required':purchaseReceiptRule.transTimeEnd[0].required}">
                  <timeStampDatePicker type="datetime" format="yyyy-MM-dd HH:mm" v-model="purchaseReceipt.transTimeEnd"  style="width: 100%" placeholder="请输入"/>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item
                  label="随货同行单:"
                  prop="travelNo">
                  <lk-input v-model="purchaseReceipt.travelNo" :maxlength="20" placeholder="请输入"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
    <lk-modal
      v-model="addRejectGoodsModalShow"
      width="500"
      title="拒收商品信息"
      @on-cancel="onAddRejectGoodsModalCancel"
    >
      <lk-form
        :label-width='130'
        label-position="right"
        :model="addRejectGoods"
        :rules="addRejectValidate"
        ref="addGoodsForm"
        style="padding-right:70px;"
      >
        <lk-row>
          <lk-form-item label="商品名称:" prop="goodsId">
            <lk-select v-model="addRejectGoods.goodsId">
              <lk-option v-for="(item,index) in rejectSelection" :key="index" :value="item.purchaseMedicineId">{{item.medicineInfoVoApprovedDrugNames}}</lk-option>
            </lk-select>
          </lk-form-item>
        </lk-row>
        <lk-row>
          <lk-form-item label="拒收数量:" prop="rejectNum">
            <DtpInputNumber
              :min="0"
              :precision="2"
              v-model="addRejectGoods.rejectNum"
              :ifNeedCheckAllNumber='true'
              :frontDecimal='7'
            />
          </lk-form-item>
        </lk-row>
        <lk-row>
          <lk-form-item label="拒收原因:" prop="rejectReason">
            <lk-input v-model="addRejectGoods.rejectReason" :maxlength="100" type="textarea"></lk-input>
          </lk-form-item>
        </lk-row>
      </lk-form>
      <div slot="footer">
        <lk-button @click="onAddRejectGoodsModalCancel">取消</lk-button>
        <lk-button type="primary"  @click="onAddRejectGoodsOk">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>

// eslint-disable-next-line import/no-extraneous-dependencies
import NP from 'number-precision';
import _ from 'lodash';
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
import DoReceiptExpand from './DoReceiptExpand.vue';
import DtpInputNumber from '../../components/DtpInputNumber';
import DtpTable from '../../components/DtpTable';

export default {
  name: 'receipt',
  components: {
    BaseFrame,
    Uploader,
    DtpInputNumber,
    DtpTable,
  },
  computed: {
    taxRateList() {
      return this.$store.state.publicParams.taxRateList;
    },
    goodsNum() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += item.purchaseReceiptInfoAcceptNum;
      });
      return res.toFixed(2);
    },
    rejectGoodsNum() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += item.purchaseReceiptInfoAcceptNum;
      });
      return res.toFixed(2);
    },
    purchaseAmount() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += (item.purchaseReceiptInfoAcceptNum * item.purchaseReceiptInfoPriceBeforeTax);
      });
      return res.toFixed(2);
    },
    rejectSelection() {
      const rejectIdArr = this.rejectData.map(item => item.purchaseMedicineMedicineId);
      const selection = this.tableData.filter(item => !rejectIdArr.includes(item.purchaseMedicineMedicineId));
      return selection;
    },
  },
  watch: {
    tableData: {
      deep: true,
      handler() {
        this.onTableChange();
      },
    },
    rejectData: {
      deep: true,
      handler() {
        this.onTableChange();
      },
    },
    'purchaseReceipt.purchaseReceiptImgInfoList': {
      deep: true,
      handler() {
        this.onTableChange();
      },
    },
    'purchasePlan.goodsType': function goodsTypeHandler() {
      if (this.purchasePlan.goodsType === 2) {
        this.rejectColumn.splice(4, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          key: 'purchaseMedicineApprovalNumber',
        });
      } else {
        this.rejectColumn.splice(4, 1, {
          title: '批准文号',
          minWidth: 116,
          key: 'purchaseMedicineApprovalNumber',
        });
      }
    },
  },
  data() {
    return {
      transportModeRequired: false,
      purchaseReceipt: {
        purchaseReceiptImgInfoList: [
          {
            temperatureImg: null,
            imgComment: null,
          },
        ],
        supplierInventory: '', // 供应商库存地址
        transportModeId: '', // 运输方式
        carryMode: '', // 承运方式
        carrier: '', // 承运单位
        licensePlate: '', // 车牌号
        transTimeStart: null, // 起运时间
        transTimeEnd: null, // 到货时间
      },
      purchaseReceiptRule: {
        purchaseReceiptImgInfoList: [
          {
            required: false,
            type: 'array',
            message: '请选择冷链商品温度附件图',
          },
        ],
        transportModeId: [
          {
            required: true,
            message: '请选择运输方式',
          },
        ],
        carryMode: [
          {
            required: true,
            message: '请选择承运方式',
          },
        ],
        carrier: [
          {
            required: true,
            message: '请选输入承运单位',
          },
        ],
        transTimeStart: [
          {
            required: false,
            validator: this.transTimeStartValidator,
            trigger: 'change',
            type: 'number',
          },
        ],
        transTimeEnd: [
          {
            required: false,
            validator: this.transTimeEndValidator,
            trigger: 'change',
            type: 'number',
          },
        ],
        travelNo: [
          {
            required: true,
            message: '请输入随货同行单号',
          },
        ],
      },
      addRejectValidate: {
        goodsId: [
          {
            required: true, message: '请选择商品', trigger: 'blur', type: 'number',
          },
        ],
        rejectNum: [
          {
            required: true, type: 'number', message: '请输入拒收数量', trigger: 'blur',
          },
        ],
        rejectReason: [
          {
            required: true, message: '请输入拒收原因', trigger: 'blur',
          },
        ],
      },
      addRejectGoods: {
        goodsId: '',
        rejectNum: 0,
        rejectReason: '',
      },
      tempInput: '',
      addRejectGoodsModalShow: false,
      paymentType: ['普通', '寄售'],
      queryParams: {
        purchaseOrderId: '',
      },
      purchasePlan: {
        code: '',
        goodsType: null,
      },
      purchaseOrder: {
        code: '',
        createUserName: '',
      },
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(DoReceiptExpand,
            {
              props: {
                row,
                goodsType: this.purchasePlan.goodsType,
              },
            }),
        },
        {
          title: '行号',
          width: 60,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          minWidth: 142,
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '规格',
          minWidth: 130,
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '生产厂家',
          minWidth: 142,
          key: 'medicineInfoVoManufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
        {
          title: '储存条件',
          minWidth: 112,
          key: 'medicineInfoVoStorageConditions',
        },
        {
          title: '产地',
          minWidth: 142,
          key: 'purchaseMedicineCountryOfOrigin',
        },
        {
          title: '医保编码',
          width: 200,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '实际数量',
          minWidth: 90,
          key: 'purchaseReceiptInfoAcceptNum',
          render: (h, { row, index }) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.tableData[index].purchaseReceiptInfoAcceptNum = value;
                this.onChangeNum(index);
              },
            },
            props: {
              value: row.purchaseReceiptInfoAcceptNum,
              placeholder: '数量',
              min: 0,
              ifNeedCheckAllNumber: true,
              frontDecimal: 7,
              precision: 2,
            },
          }),
        },
        {
          title: '实际含税单价(元)',
          minWidth: 130,
          key: 'purchaseReceiptInfoPriceBeforeTax',
          render: (h, { row, index }) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.tableData[index].purchaseReceiptInfoPriceBeforeTax = value;
                this.onChangeNum(index);
              },
            },
            props: {
              value: row.purchaseReceiptInfoPriceBeforeTax,
              placeholder: '请输入',
              min: 0,
              precision: 6,
              maxlength: 12,
              ifNeedCheckAllNumber: true,
              frontDecimal: 5
            },
          }),
        },
        {
          title: '批号',
          minWidth: 116,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.tableData[index].purchaseReceiptInfoGoodsBatchNum = e.target.value;
              },
            },
            props: {
              value: row.purchaseReceiptInfoGoodsBatchNum,
              placeholder: '请输入',
              maxlength: 30,
            },
          }),
        },
        {
          title: '生产日期',
          minWidth: 144,
          render: (h, { row, index }) => h('timeStampDatePicker', {
            on: {
              'on-change': (value) => {
                this.validateProduct(index, value);
                this.tableData[index].purchaseReceiptInfoProductionDate = value;
              },
            },
            class: {
              'is-expiry': row.isProdDateExpiry,
            },
            props: {
              editable: false,
              value: row.purchaseReceiptInfoProductionDate,
              placeholder: '请选择',
              options: {
                disabledDate(date) {
                  return date && date.valueOf() > Date.now();
                },
              },
            },
          }),
        },
        {
          title: '有效日期',
          minWidth: 144,
          render: (h, { row, index }) => h('timeStampDatePicker', {
            on: {
              'on-change': (value) => {
                this.tableData[index].purchaseReceiptInfoExpiryDate = value;
              },
            },
            props: {
              value: row.purchaseReceiptInfoExpiryDate,
              placeholder: '请选择',
              editable: false,
              options: {
                disabledDate(date) {
                  return date && date.valueOf() < Date.now();
                },
              },
            },
          }),
        },
        {
          title: '进项税率(%)',
          minWidth: 102,
          key: 'purchaseReceiptInfoTaxRate',
          render: (h, { row, index }) => {
            const optionArr = this.taxRateList.map(item => h('lk-option',
              {
                props: {
                  value: item.value,
                },
              }, item.name));
            return h('lk-select',
              {
                on: {
                  'on-change': (value) => {
                    this.tableData[index].purchaseReceiptInfoTaxRate = value;
                    this.onChangeNum(index);
                  },
                },
                props: {
                  value: row.purchaseReceiptInfoTaxRate,
                  placeholder: `${row.purchaseReceiptInfoTaxRate}`,
                },
              },
              optionArr);
          },
        },
        {
          title: '起点温度(℃)',
          key: 'purchaseReceiptInfoStartTemperature',
          minWidth: 116,
          render: (h, { row, index }) => {
            let disabled = true;
            let placeholder = '';
            if (row.isColdChain === 1) {
              disabled = false;
              placeholder = '必填';
            }
            return h('lk-input', {
              on: {
                'on-blur': (e) => {
                  this.tableData[index].purchaseReceiptInfoStartTemperature = e.target.value;
                },
              },
              props: {
                value: row.purchaseReceiptInfoStartTemperature,
                placeholder,
                disabled,
              },
            });
          },
        },
        {
          title: '到店温度(℃)',
          key: 'purchaseReceiptInfoEndTemperature',
          minWidth: 116,
          render: (h, { row, index }) => {
            let disabled = true;
            let placeholder = '';
            if (row.isColdChain === 1) {
              disabled = false;
              placeholder = '必填';
            }
            return h('lk-input', {
              on: {
                'on-blur': (e) => {
                  this.tableData[index].purchaseReceiptInfoEndTemperature = e.target.value;
                },
              },
              props: {
                value: row.purchaseReceiptInfoEndTemperature,
                placeholder,
                disabled,
              },
            });
          },
        },
        {
          title: '税额(元)',
          key: 'purchaseReceiptInfoTotalTax',
          minWidth: 116,
        },
        {
          title: '不含税总额(元)',
          key: 'purchaseReceiptInfoTotalPriceAfterTax',
          minWidth: 140,
        },
        {
          title: '检验报告',
          key: 'purchaseReceiptInfoReportUrl',
          minWidth: 230,
          render: (h, { row, index }) => h(Uploader, {
            props: {
              url: row.purchaseReceiptInfoReportUrl,
              maxSize: 20,
              able: true,
              format: ['jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'rar', 'zip', '7z', 'tar', 'gz'],
            },
            on: {
              handle: (val) => {
                this.tableData[index].purchaseReceiptInfoReportUrl = val || '';
              },
            },
          }),
        },
        {
          title: '结束收货',
          key: 'finishReceipt',
          minWidth: 86,
          render: (h, { row, index }) => h('lk-switch',
            {
              props: {
                value: row.finishReceipt,
              },
              on: {
                'on-change': (value) => {
                  this.tableData[index].finishReceipt = value;
                },
              },
            },
            [
              h('span', {
                props: {
                },
                slot: 'open',

              }, '是'),
              h('span', {
                props: {
                },
                slot: 'close',

              }, '否')]),
        },
        {
          title: '备注',
          minWidth: 130,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.tableData[index].purchaseMedicineComment = e.target.value;
              },
            },
            props: {
              value: row.purchaseMedicineComment,
              placeholder: '请输入',
              disabled: !row.finishReceipt,
              maxlength: 100,
            },
          }),
        },
        {
          title: '操作',
          minWidth: 66,
          render: (h, { index }) => h('lk-button',
            {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.tableData.splice(index, 1);
                },
              },
            },
            '删除'),
        },
      ],
      tableData: [],
      rejectColumn: [
        {
          title: '行号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '商品编码',
          minWidth: 116,
          key: 'purchaseMedicineDrugSerialCode',
        },
        {
          title: '通用名称',
          minWidth: 116,
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '产地',
          minWidth: 116,
          key: 'purchaseMedicineCountryOfOrigin',
        },
        {
          title: '批准文号',
          minWidth: 116,
          key: 'purchaseMedicineApprovalNumber',
        },
        {
          title: '规格',
          minWidth: 116,
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '生产厂家',
          minWidth: 116,
          key: 'medicineInfoVoManufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 116,
          key: 'medicineInfoVoMah',
          tooltip: true,
        },
        {
          title: '拒收数量',
          minWidth: 116,
          key: 'rejectNum',
        },
        {
          title: '拒收原因',
          minWidth: 116,
          key: 'rejectReason',
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { index }) => [
            h('lk-button',
              {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.rejectData.splice(index, 1);
                  },
                },
              },
              '删除'),
          ],
        },
      ],
      rejectData: [],
      transportModeList: [
        {
          label: '供应商普通货车',
          value: 1,
        },
        {
          label: '供应商冷藏车',
          value: 2,
        },
        {
          label: '供应商冷藏箱',
          value: 3,
        },
        {
          label: '委托第三方运输',
          value: 4,
        },
      ],
      carryModeList: [
        {
          label: '第三方普通货车',
          value: 1,
        },
        {
          label: '第三方冷藏车',
          value: 2,
        },
        {
          label: '第三方冷藏箱',
          value: 3,
        },
      ],
    };
  },
  methods: {
    checkoutRate() {
      this.onSubmit();
    },
    onTableChange() {
      // 遍历数组，决定补充信息部分验证规则
      let hasColdMedicine = false;
      let hasMedicine = false;
      this.tableData.forEach((item) => {
        const acceptNum = Number(item.purchaseReceiptInfoAcceptNum);
        if (acceptNum > 0 && item.isColdChain === 1) {
          hasColdMedicine = true;
        }
        if (acceptNum > 0 && item.isColdChain === 2) {
          hasMedicine = true;
        }
      });
      // 存在冷链商品，温度附件图，运输方式，起运时间，到货时间必填
      // 温度附件图还需考虑图片数量
      // 当存在一张温度附件图就非必填
      if (hasColdMedicine) {
        this.changeValidateRulesRequired({
          purchaseReceiptImgInfoList: true,
          transportModeId: true,
          transTimeStart: true,
          transTimeEnd: true,
        });
      } else if (hasMedicine) {
        // 存在普通商品，运输方式必填
        this.changeValidateRulesRequired({
          purchaseReceiptImgInfoList: false,
          transportModeId: true,
          transTimeStart: false,
          transTimeEnd: false,
        });
      } else {
        // 不存在商品，全都非必填
        this.changeValidateRulesRequired({
          purchaseReceiptImgInfoList: false,
          transportModeId: false,
          transTimeStart: false,
          transTimeEnd: false,
        });
      }
    },
    changeValidateRulesRequired(rulesObject) {
      const purchaseReceiptRule = this.purchaseReceiptRule;
      Object.keys(rulesObject).forEach((key) => {
        purchaseReceiptRule[key][0].required = rulesObject[key];
      });
    },
    transTimeStartValidator(rule, value) {
      const targetDate = value;
      const { required } = rule;
      const currentTimeStamp = (new Date()).getTime();
      if (targetDate) {
        // if (targetDate instanceof Date) {
        const targetTimeStamp = targetDate;// .getTime();
        if (currentTimeStamp <= targetTimeStamp) {
          return new Error('起运时间应早于当前时间');
        }
        if (this.purchaseReceipt.transTimeEnd) {
          const transTimeEndTimeStamp = this.purchaseReceipt.transTimeEnd;
          if (transTimeEndTimeStamp <= targetTimeStamp) {
            return new Error('起运时间应早于到货时间');
          }
        }
        // } else {
        //   return new Error('请输入正确的日期');
        // }
      }
      if (required && !targetDate) {
        return new Error('请输入起运时间');
      }
      return true;
    },
    transTimeEndValidator(rule, value) {
      const targetDate = value;
      const { required } = rule;
      const currentTimeStamp = (new Date()).getTime();
      if (targetDate) {
        // if (targetDate instanceof Date) {
        const targetTimeStamp = targetDate;// .getTime();
        if (currentTimeStamp < targetTimeStamp) {
          return new Error('到货时间应早于当前时间');
        }
        if (this.purchaseReceipt.transTimeStart) {
          const transTimeStartTimeStamp = this.purchaseReceipt.transTimeStart;// .getTime();
          if (transTimeStartTimeStamp >= targetTimeStamp) {
            return new Error('到货时间应晚于起运时间');
          }
        }
        // } else {
        //   return new Error('请输入正确的日期');
        // }
      }
      if (required && !targetDate) {
        return new Error('请输入到货时间');
      }
      return true;
    },
    validateProduct(index, value) {
      const item = this.tableData[index];
      const prodDate = utils.toTimestamp(value);
      const goodsStoreId = item.purchaseMedicineMedicineId;
      const data = {
        prodDate, goodsStoreId,
      };
      if (!data.prodDate) {
        item.isProdDateExpiry = false;
        return;
      }
      this.$store.commit('setDisableLoading', true);
      purchase.checkProdDate(data).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.isProdDateExpiry == 1) {
            item.isProdDateExpiry = true;
            this.$Message.error('存在生产时证件已过期的商品，请更新证件/更正生产日期');
          } else {
            item.isProdDateExpiry = false;
          }
        }
      }).catch((err) => {
        item.isProdDateExpiry = false;
        utils.handleError(err);
      });
    },
    onAddRejectGoodsOk() {
      const addGoodsForm = this.$refs.addGoodsForm;
      addGoodsForm.validate().then((validate) => {
        if (validate) {
          // add table
          const { goodsId, rejectNum, rejectReason } = this.addRejectGoods;
          let resItem = {};
          this.tableData.forEach((item) => {
            if (item.purchaseMedicineId === goodsId) {
              resItem = { ...item };
            }
          });
          resItem.rejectNum = rejectNum;
          resItem.rejectReason = rejectReason;
          this.rejectData.push(resItem);
          // reset
          this.addRejectGoodsModalShow = false;
          this.resetAddGoods();
        } else {
          this.$Message.error('输入数据不符合规范');
        }
      });
    },
    resetAddGoods() {
      // this.addRejectGoods = {};
      this.$refs.addGoodsForm.resetFields();
    },
    resetTableData() {
      this.tableData = [];
    },
    resetRejectData() {
      this.rejectData = [];
    },
    resetReceipt() {
      this.purchaseReceipt = {
        purchaseReceiptImgInfoList: [
          {
            temperatureImg: null,
            imgComment: null,
          },
        ],
        supplierInventory: '', // 供应商库存地址
        transportModeId: '', // 运输方式
        licensePlate: '', // 车牌号
        transTimeStart: null, // 起运时间
        transTimeEnd: null, // 到货时间
      };
    },
    showAddRejectGoods() {
      this.addRejectGoodsModalShow = true;
    },
    onAddRejectGoodsModalCancel() {
      this.addRejectGoodsModalShow = false;
      this.resetAddGoods();
    },
    imgHandle(src) {
      if (this.purchaseReceipt.purchaseReceiptImgInfoList.length >= 5) {
        this.$Message.error('最多添加5张温度附件图');
        return;
      }
      this.purchaseReceipt.purchaseReceiptImgInfoList.push({
        temperatureImg: src,
        imgComment: this.tempInput,
      });
      this.tempInput = '';
    },
    onChangeNum(index) {
      const row = this.tableData[index];
      let purchaseReceiptInfoAcceptNum = row.purchaseReceiptInfoAcceptNum;
      let purchaseReceiptInfoPriceBeforeTax = row.purchaseReceiptInfoPriceBeforeTax;
      let purchaseReceiptInfoTaxRate = row.purchaseReceiptInfoTaxRate;
      if (purchaseReceiptInfoAcceptNum && purchaseReceiptInfoPriceBeforeTax && purchaseReceiptInfoTaxRate !== '') {
        purchaseReceiptInfoAcceptNum = Number(purchaseReceiptInfoAcceptNum);
        purchaseReceiptInfoPriceBeforeTax = Number(purchaseReceiptInfoPriceBeforeTax);
        purchaseReceiptInfoTaxRate = Number(purchaseReceiptInfoTaxRate / 100);
        if (utils.isNumber(purchaseReceiptInfoAcceptNum) && utils.isNumber(purchaseReceiptInfoPriceBeforeTax)
          && utils.isNumber(purchaseReceiptInfoTaxRate)
        ) {
          const purchaseReceiptInfoTotalTax = NP.divide(NP.times(purchaseReceiptInfoAcceptNum, purchaseReceiptInfoPriceBeforeTax, purchaseReceiptInfoTaxRate), (1 + purchaseReceiptInfoTaxRate));
          const purchaseReceiptInfoTotalPriceAfterTax = NP.divide(NP.times(purchaseReceiptInfoAcceptNum, purchaseReceiptInfoPriceBeforeTax), (1 + purchaseReceiptInfoTaxRate));
          row.purchaseReceiptInfoTotalTax = purchaseReceiptInfoTotalTax.toFixed(6);
          row.purchaseReceiptInfoTotalPriceAfterTax = purchaseReceiptInfoTotalPriceAfterTax.toFixed(6);
        }
      }
    },
    // eslint-disable-next-line func-names
    onBtnClick: _.throttle(function (name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'submit') {
        this.checkoutRate();
      }
    }, 3000),
    onSubmit() {
      this.$refs.purchaseReceiptForm.validate((valid) => {
        if (valid) {
          // adapt data
          const purchaseMedicineInfoVoList = [];
          const purchaseOrder = {
            id: this.queryParams.purchaseOrderId,
          };
          const purchaseReceiptImgInfoList = [];
          const purchaseReceipt = { ...this.purchaseReceipt };
          let dataIsNotFilled = false;
          let codeNotFilled = false;
          let codeNotRight = false;
          let hasColdMedicine = false;
          let numNotValidate = false;
          let dateErrorLabel = false;
          let RealNumBigLabel = false;
          let shouldDelete = false;
          let temperatureNotAllow = false;
          let dateNotValidate = false;
          // 数据为空，不让提交
          if (this.tableData <= 0) {
            this.$Message.error('商品为空时无法提交收货单，请至少选择一个商品进行收货');
            return;
          }
          this.tableData.forEach((item) => {
            const purchaseMedicine = {
              id: item.purchaseMedicineId,
              comment: item.purchaseMedicineComment,
              medicineId: item.purchaseMedicineMedicineId,
            };
            const codeGoods = item.isColdChain === 1;
            const startTemperature = item.purchaseReceiptInfoStartTemperature;
            const endTemperature = item.purchaseReceiptInfoEndTemperature;
            const purchaseReceiptInfoProductionDate = item.purchaseReceiptInfoProductionDate;
            const purchaseReceiptInfoExpiryDate = item.purchaseReceiptInfoExpiryDate;
            let cancelValidate = false;
            item.rejectNum = 0;
            item.rejectReason = '';
            this.rejectData.forEach((rejectItem) => {
              if (rejectItem.purchaseMedicineMedicineId === item.purchaseMedicineMedicineId) {
                item.rejectNum = rejectItem.rejectNum;
                item.rejectReason = rejectItem.rejectReason;
              }
            });
            const purchaseReceiptInfo = {
              priceBeforeTax: item.purchaseReceiptInfoPriceBeforeTax,
              acceptNum: Number(item.purchaseReceiptInfoAcceptNum),
              goodsBatchNum: item.purchaseReceiptInfoGoodsBatchNum ? item.purchaseReceiptInfoGoodsBatchNum : '',
              productionDate: purchaseReceiptInfoProductionDate,
              expiryDate: purchaseReceiptInfoExpiryDate,
              taxRate: item.purchaseReceiptInfoTaxRate,
              finishReceipt: item.finishReceipt ? 1 : 2,
              rejectNum: Number(item.rejectNum) ? Number(item.rejectNum) : 0,
              rejectReason: item.rejectReason ? item.rejectReason : '',
              reportUrl: item.purchaseReceiptInfoReportUrl,
            };
            const TodoReceiptNum = item.purchaseMedicineTodoReceiptNum;
            const acceptNum = purchaseReceiptInfo.acceptNum;
            const rejectNum = purchaseReceiptInfo.rejectNum;
            if ((acceptNum + rejectNum) == TodoReceiptNum) {
              purchaseReceiptInfo.finishReceipt = 1;
            }
            if (item.isProdDateExpiry) {
              dateNotValidate = true;
            }
            // 实际收货为0 将取消校验
            if (acceptNum <= 0) {
              cancelValidate = true;
            }
            // 检验是否为数字
            if (!_.isFinite(acceptNum)
              || !_.isFinite(rejectNum)
              || !_.isFinite(purchaseReceiptInfo.priceBeforeTax)) {
              numNotValidate = true;
            }
            // 判断温度是否是数字
            if (!_.isFinite(Number(startTemperature))) {
              codeNotRight = true;
            }
            if (!_.isFinite(Number(endTemperature))) {
              codeNotRight = true;
            }
            // 不取消收货
            if ((acceptNum + rejectNum) > TodoReceiptNum) {
              RealNumBigLabel = true;
            }
            // 实收拒收之和为0 ，并且未结束收货
            if ((acceptNum + rejectNum) <= 0 && purchaseReceiptInfo.finishReceipt != 1) {
              shouldDelete = true;
            }
            if ((acceptNum + rejectNum) > 0) {
              // 校验非空
              if ((!_.isFinite(Number(purchaseReceiptInfo.taxRate))
                || !purchaseReceiptInfo.goodsBatchNum
                || purchaseReceiptInfo.taxRate === '') && !cancelValidate) {
                dataIsNotFilled = true;
              }
              // 非中药饮片生产日期和有效日期必填
              if (this.purchasePlan.goodsType != 3) {
                if ((!purchaseReceiptInfo.productionDate
                  || !purchaseReceiptInfo.expiryDate) && !cancelValidate) {
                  dataIsNotFilled = true;
                }
              }
              // 日期不正确
              if (purchaseReceiptInfo.productionDate && purchaseReceiptInfo.expiryDate
              && (purchaseReceiptInfo.productionDate >= purchaseReceiptInfo.expiryDate)) {
                dateErrorLabel = true;
              }
              // 判断温度是否是数字
              if (_.isFinite(Number(startTemperature))) {
                purchaseReceiptInfo.startTemperature = startTemperature;
              }
              if (_.isFinite(Number(endTemperature))) {
                purchaseReceiptInfo.endTemperature = endTemperature;
              }
              if (codeGoods) {
                const startTemperatureNum = Number(purchaseReceiptInfo.startTemperature);
                const endTemperatureNum = Number(purchaseReceiptInfo.endTemperature);
                if (((startTemperature.trim() === '') || (endTemperature.trim() === '')) && !cancelValidate) {
                  codeNotFilled = true;
                }
                if ((startTemperatureNum < item.tempLowerLimit || endTemperatureNum < item.tempLowerLimit) && !cancelValidate) {
                  temperatureNotAllow = true;
                }
                if ((startTemperatureNum > item.tempUpperLimit || endTemperatureNum > item.tempUpperLimit) && !cancelValidate) {
                  temperatureNotAllow = true;
                }
                if (acceptNum > 0) {
                  hasColdMedicine = true;
                }
              }
            }
            purchaseMedicineInfoVoList.push({
              purchaseMedicine, purchaseReceiptInfo,
            });
          });
          if (dateNotValidate) {
            this.$Message.error('存在生产时证件已过期的商品，请更新证件/更正生产日期');
            return;
          }
          this.purchaseReceipt.purchaseReceiptImgInfoList.forEach((item) => {
            if (item.temperatureImg) {
              purchaseReceiptImgInfoList.push(item);
            }
          });
          // 冷链商品温度附件图验证
          if (hasColdMedicine && purchaseReceiptImgInfoList.length <= 0) {
            this.$Message.error('冷链商品温度附件图必填');
            return;
          }
          if (RealNumBigLabel) {
            this.$Message.error('实际数量不能大于待收数量');
            return;
          }
          if (numNotValidate) {
            this.$Message.error('实际数量、拒收数量或实际含税单价请输入整数');
            return;
          }
          if (shouldDelete) {
            this.$Message.error('商品实收数量为0或空：若不等该品补发，请在相应行点击结束收货；若继续待收，请在本批收货单中将其删除，商品回至待收区。');
            return;
          }
          // 验证数据完整度
          if (dataIsNotFilled) {
            this.$Message.error('请填写完整数据再提交');
            return;
          }
          // 验证冷链商品温度必填
          if (codeNotFilled) {
            this.$Message.error('冷链商品必须填写起点和到店温度');
            return;
          }
          // 验证冷链商品温度是否是数字
          if (codeNotRight) {
            this.$Message.error('冷链商品起点和到店温度请填写正确数字');
            return;
          }
          if (temperatureNotAllow) {
            this.$Message.error('温度不达标请核实后再进行操作');
            return;
          }
          // 日期校验
          if (dateErrorLabel) {
            this.$Message.error('有效日期不能早于生产日期');
            return;
          }

          // if (purchaseReceipt.transTimeStart) {
          //   purchaseReceipt.transTimeStart = utils.toTimestamp(purchaseReceipt.transTimeStart);
          // }
          // if (purchaseReceipt.transTimeEnd) {
          //   purchaseReceipt.transTimeEnd = utils.toTimestamp(purchaseReceipt.transTimeEnd);
          // }

          const data = {
            purchaseOrder,
            purchaseMedicineInfoVoList,
            purchaseReceiptImgInfoList,
            purchaseReceipt,
          };
          const alertList = [];
          this.tableData.forEach((item, index) => {
            // 进项和销项不相等，但是有可能一个为空，一个为0
            const output13 = (item.purchaseReceiptInfoTaxRate == 3 || item.purchaseReceiptInfoTaxRate == 0 || item.purchaseReceiptInfoTaxRate === '') && item.medicineInfoVoOutputTaxRate == 13;
            const output3 = (item.purchaseReceiptInfoTaxRate == 13 && item.medicineInfoVoOutputTaxRate == 3);
            const output0 = (item.purchaseReceiptInfoTaxRate == 3 || item.purchaseReceiptInfoTaxRate == 13) && (item.medicineInfoVoOutputTaxRate == 0 || item.medicineInfoVoOutputTaxRate == '');
            if ((output13 || output3 || output0) && item.purchaseReceiptInfoAcceptNum > 0) {
              alertList.push(`${item.medicineInfoVoDrugSerialCode + item.medicineInfoVoApprovedDrugNames}`);
            }
          });
          if (alertList.length > 0) {
            this.$Modal.confirm({
              title: '提示',
              content: `${alertList.join('、')}进项税率和销项税率异常，如确认继续提交需财务审批`,
              okText: '确认',
              cancelText: '取消',
              onOk: () => {
                this.submitRequest(data);
              },
            });
          } else {
            this.submitRequest(data);
          }
        } else {
          this.$Message.error('请填写完整数据再提交');
        }
      });
    },
    submitRequest(params) {
      purchase.receiptAdd(params).then((res) => {
        const code = res.data.status;
        if (code === 200) {
          this.resetAll();
          this.closeLeavelModal().then(() => {
            this.jumpToList();
          });
          this.$Message.success('提交成功');
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    resetAll() {
      this.resetAddGoods();
      this.resetTableData();
      this.resetRejectData();
      this.resetReceipt();
    },
    jumpToList() {
      this.$router.push({
        name: 'todoReceiptList',
      });
    },
    onCancel() {
      // reset and jump
      this.resetAll();
      this.closeLeavelModal().then(() => {
        this.jumpToList();
      });
    },
    closeLeavelModal() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.$store.commit('setLeaveModal', false);
          resolve();
        });
      });
    },
    getData() {
      return new Promise((resolve, reject) => {
        this.queryParams.purchaseOrderId = this.$route.params.purchaseOrderId;
        const queryParams = Object.assign({}, this.queryParams);
        // console.log(queryParams);
        purchase.receiptDetail(queryParams).then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            if (res.data.data.purchaseOrder) {
              this.purchaseOrder.code = res.data.data.purchaseOrder.code;
              this.purchaseOrder.supplierName = res.data.data.purchaseOrder.supplierName;
              this.purchaseOrder.paymentName = this.paymentType[res.data.data.purchaseOrder.payment - 1];
              this.purchaseOrder.createTime = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD HH:mm');
            }
            if (res.data.data.purchasePlan) {
              this.purchasePlan.code = res.data.data.purchasePlan.code;
              this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
              this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
              this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
              this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
              this.purchasePlan.goodsType = res.data.data.purchasePlan.goodsType;
            }
            if (res.data.data.purchaseReceipt) {
            //   const purchaseReceipt = res.data.data.purchaseReceipt;
            // if (purchaseReceipt.transTimeStart) {
            //   purchaseReceipt.transTimeStart = new Date(purchaseReceipt.transTimeStart);
            // }
            // if (purchaseReceipt.transTimeEnd) {
            //   purchaseReceipt.transTimeEnd = new Date(purchaseReceipt.transTimeEnd);
            // }
              this.purchaseReceipt = { purchaseReceiptImgInfoList: [], ...res.data.data.purchaseReceipt };
            }
            // this.medicineInfoVoList = [];
            res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              if (!result.purchaseReceiptInfoTotalPriceAfterTax) {
                result.purchaseReceiptInfoTotalPriceAfterTax = '';
              }
              if (!result.purchaseReceiptInfoStartTemperature) {
                result.purchaseReceiptInfoStartTemperature = '';
              }
              if (!result.purchaseReceiptInfoEndTemperature) {
                result.purchaseReceiptInfoEndTemperature = '';
              }
              if (!result.medicineInfoVoInputTaxRate && result.medicineInfoVoInputTaxRate !== 0) {
                result.purchaseReceiptInfoTaxRate = '';
              } else {
                result.purchaseReceiptInfoTaxRate = result.medicineInfoVoInputTaxRate;
              }
              if (!result.purchaseReceiptInfoTotalTax) {
                result.purchaseReceiptInfoTotalTax = '';
              }
              if (!result.purchaseReceiptInfoGoodsBatchNum) {
                result.purchaseReceiptInfoGoodsBatchNum = '';
              }
              result.purchaseReceiptInfoReportUrl = result.purchaseReceiptInfoReportUrl || '';
              if (!result.purchaseReceiptInfoAcceptNum) {
                result.purchaseReceiptInfoAcceptNum = 0;
              }
              if (!result.purchaseReceiptInfoPriceBeforeTax) {
                result.purchaseReceiptInfoPriceBeforeTax = 0;
              }
              if (!result.purchaseMedicineComment) {
                result.purchaseMedicineComment = '';
              }
              if (result.finishReceipt === 1) {
                result.finishReceipt = true;
              } else {
                result.finishReceipt = false;
              }
              result.isProdDateExpiry = false;
              console.log(result);
              this.tableData.push(result);
            });
            this.tableData.forEach((item, index) => {
              this.onChangeNum(index);
            });
            if (res.data.data.purchaseReceiptImgInfoList) {
              this.purchaseReceipt.purchaseReceiptImgInfoList = res.data.data.purchaseReceiptImgInfoList;
            }
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
  },
  mounted() {
    this.getData().then(() => {
      this.$watch('tableData', () => {
        this.onTableChange();
        this.$store.commit('setLeaveModal', true);
      }, { deep: true });
      this.$watch('rejectData', () => {
        this.onTableChange();
        this.$store.commit('setLeaveModal', true);
      }, { deep: true });
      this.$watch('purchaseReceipt.purchaseReceiptImgInfoList', () => {
        this.onTableChange();
        this.$store.commit('setLeaveModal', true);
      }, { deep: true });
      this.$watch('purchaseReceipt', () => {
        this.$store.commit('setLeaveModal', true);
      }, { deep: true });
    }).catch((err) => { utils.handleError(err); });
  },
};
</script>
<style lang="less">
.do-receipt{
  .temp-img{
    height: 80px;
    width: 80px;
  }
  .other-card{
    margin-top: 30px;
  }
  .rejectTable{
    margin-bottom: 16px;
  }
  .ivu-table-cell{
    .ivu-btn{
      padding:0;
    }
  }
  .is-expiry{
    .ivu-input{
      border: 1px solid red;
    }
  }
}
</style>
